// internal
import { axios, def, handleResponse, handleError } from './internal';

// client-shared
import { storage } from '@goldblack/client-storage';

function AdminObjectRemove(service, type, id) {
    storage.transience.setState(`${service}.${type}.loading`, true);

    axios
        .post('/api/admin_object_remove', {
            service,
            type,
            id,
        })
        .then((res) => {
            switch (res.data.code) {
                case def.ErrorCode.OK:
                    const callback = (item) => item._id === id;
                    storage.transience.removeState(`${service}.${type}.data`, callback);

                    storage.transience.setState('internal.success', 'The item has been removed.');
                    break;
                case def.ErrorCode.ADMIN_FILTER_OPTION_IN_USE:
                    storage.transience.setState(
                        'internal.error',
                        `This option is used by: ${res.data.data.filters.join(', ')} filter. Remove it from those filters first.`,
                    );
                    break;
                default:
                    handleResponse(res);
                    break;
            }
        })
        .catch((err) => {
            handleError(err);
        })
        .finally(() => {
            storage.transience.setState(`${service}.${type}.loading`, false);
        });
}

export { AdminObjectRemove };
